import { useMonitor } from '../use-monitor';

export function useMonitorEditIssueTemplateFormLoad() {
  return useMonitor('edit-issue-template-form-load');
}
